import { useCallback, useState } from "react";
import { DebugButtons } from "./DebugButtons";
import styles from "./ParserDevelopmentTool.module.css";
import { SourceModal } from "./SourceModal";

export type ParserDevelopmentToolType = {
  developmentMode: boolean;
  parserOutput?: string;
  fetchCurrentParserOutputs: (onLoad: () => void) => void;
  reparseCurrentDatasets: () => void;
};

export const ParserDevelopmentTool = ({
  parserOutput,
  developmentMode,
  fetchCurrentParserOutputs,
  reparseCurrentDatasets,
}: ParserDevelopmentToolType) => {
  const [showParserOutput, setShowParserOutput] = useState<boolean>(false);

  var onReparse = useCallback(() => reparseCurrentDatasets(), [reparseCurrentDatasets]);

  var onParserOutput = useCallback(() => {
    fetchCurrentParserOutputs(() => setShowParserOutput(true));
  }, [fetchCurrentParserOutputs]);

  return (
    <div className={styles.main}>
      <SourceModal show={showParserOutput} source={parserOutput ?? ""} setShow={setShowParserOutput} />
      <DebugButtons debugMode={developmentMode} onReparse={onReparse} onParserOutput={onParserOutput} />
    </div>
  );
};
